class HHLoginForm extends HTMLElement {
    constructor() {
      super();

      this.$submit = this.querySelector('.js-login-submit')
      this.$loginForm = this.querySelector('#customer_login')

      this.email = this.querySelector('#CustomerEmail')
      this.passwd = this.querySelector('#CustomerPassword')
      this.recoverEmail = this.querySelector('#RecoverEmail')

      this.emailError = this.querySelector('.js-LoginForm-Email')
      this.recoverRmailError = this.querySelector('.js-LoginForm-RecoverEmail')
      this.passwdError = this.querySelector('.js-LoginForm-Password')
    }

    connectedCallback() {
      this.$submit.addEventListener('click', this.loginFormSubmit.bind(this))
    }

    validateEmail(elementValue) {
      const mailformat = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      return elementValue.match(mailformat)
    }

    loginFormSubmit(event) {
      event.preventDefault();

      let valid = true

      if (this.email.value === '') {
        this.emailError.classList.remove('hidden')
        this.emailError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
        if (valid) {
          this.emailError.querySelector('.js-customer-error-wrap').focus()
          valid = false
        }
        this.email.classList.add('has-error')
      } else if (this.email.value !== '' && !this.validateEmail(this.email.value)) {
        this.emailError.classList.remove('hidden')
        this.emailError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
        this.emailError.querySelector('.js-error-required').classList.remove('hidden')
        if (valid) {
          this.emailError.querySelector('.js-customer-error-wrap').focus()
          valid = false
        }
        this.email.classList.add('has-error')
      } else {
        this.emailError.classList.add('hidden')
        this.email.classList.remove('has-error')
      }

      if (this.passwd.value === '') {
        this.passwdError.classList.remove('hidden')
        if (valid) {
          this.passwdError.querySelector('.js-customer-error-wrap').focus()
          valid = false
        }
        this.passwd.classList.add('has-error')
      } else {
        this.passwdError.classList.add('hidden')
        this.passwd.classList.remove('has-error')
      }


      if (valid) {
        this.$loginForm.submit()
      }
    }
  }

  customElements.define("hh-login-form", HHLoginForm);
